// extracted by mini-css-extract-plugin
export default {"agree_check_list_wrap":"Join_agree_check_list_wrap__MTdUG","arrowIcon":"Join_arrowIcon__oeQSD"};